import './Stats.css';

const stats = () => {
  return (
    <div className='Stats_wrapper'>
      <div className='Stats_about'>
        <h1 className='Stats_header'>About The Stats</h1>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;Every game at The Toad awards some points. We
          tweak the formula a tiny bit from year-to-year, and longer games get a
          bit more consideration (and shorter games a bit less). But the idea
          roughly is something like this: 7 points for first place, 3 points for
          second, 1 point for third, 0 points for last. Thus winning is richly
          compensated, but every finish matters. In addition, players can begin
          the tournament with a point, for not using their veto.
        </p>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;It's worth noting that the four Finalists play
          an additional game versus the rest of the field, furthering their
          totals, and possibly exaggerating the actual lead they had over the
          others in the tournament.
        </p>
      </div>
      <div className='Stats_results'>
        <h1 className='Stats_header'>All-Time Results</h1>
        <div className='centerText Stats_nameList'>
          <ul>
            <li>
              <strong>Andrew Emerick (299)</strong>
            </li>
            <li>Antony Saccenti (270)</li>
            <li>Scott Saccenti (237)</li>
            <li>Rob Murray (222)</li>
            <li>Kyle Smith (212)</li>
            <li>Donte Saccenti (209)</li>
            <li>Eugene Yee (200)</li>
            <li>Chris Wildes (190)</li>
            <li>Dalton Versak (175)</li>
            <li>Rodney Bacigalupo (154)</li>
            <li>Joe Yaure (154)</li>
            <li>Chad Weaver (147)</li>
            <li>Preston Saccenti (126)</li>
            <li>Marcy Morelli (124)</li>
            <li>Aaron Blair (115)</li>
            <li>Randy Buehler (102)</li>
            <li>Andy Latto (93)</li>
            <li>Jay Fox (57)</li>
            <li>Chris Yaure (49)</li>
            <li>Hilary Smith (42)</li>
            <li>Christy Applegate (36)</li>
            <li>Henry Dove (27)</li>
            <li>Sceadeau D'Tela (23)</li>
            <li>Eric Wrobel (22)</li>
            <li>Dave Rohde (19)</li>
            <li>Tessa Lytle (17)</li>
            <li>Amy Rule (14)</li>
            <li>Norman Rule (8)</li>
          </ul>
        </div>
        <br />
      </div>
      <div className='Stats_2017'>
        <h1 className='Stats_header'>2017 Totals</h1>
        <div className='centerText Stats_nameList'>
          <ul>
            <li>
              <strong>Rob Murray (38)</strong>
            </li>
            <li>Andrew Emerick (25)</li>
            <li>Antony Saccenti (21)</li>
            <li>Eugene Yee (21)</li>
            <li>Donte Saccenti (18)</li>
            <li>Marcy Morelli (16)</li>
            <li>Scott Saccenti (14)</li>
            <li>Amy Rule (14)</li>
            <li>Kyle Smith (13)</li>
            <li>Hilary Smith (11)</li>
            <li>Rodney Bacigalupo (9)</li>
            <li>Norman Rule (8)</li>
          </ul>
        </div>
        <br />
      </div>
      <div className='Stats_2018'>
        <h1 className='Stats_header'>2018 Totals</h1>
        <div className='centerText Stats_nameList'>
          <ul>
            <li>
              <strong>Eugene Yee (34)</strong>
            </li>
            <li>Andrew Emerick (30)</li>
            <li>Donte Saccenti (28)</li>
            <li>Rob Murray (22)</li>
            <li>Andy Latto (21)</li>
            <li>Antony Saccenti (20)</li>
            <li>Kyle Smith (19)</li>
            <li>Scott Saccenti (19)</li>
            <li>Rodney Bacigalupo (19)</li>
            <li>Hilary Smith (13)</li>
            <li>Dave Rohde (9)</li>
            <li>Chris Wildes (7)</li>
          </ul>
        </div>
        <br />
      </div>
      <div className='Stats_2019'>
        <h1 className='Stats_header'>2019 Totals</h1>
        <div className='centerText Stats_nameList'>
          <ul>
            <li>
              <strong>Randy Buehler (40)</strong>
            </li>
            <li>Kyle Smith (36)</li>
            <li>Andrew Emerick (29)</li>
            <li>Sceadeau D'Tela (23)</li>
            <li>Jay Fox (23)</li>
            <li>Eric Wrobel (22)</li>
            <li>Scott Saccenti (22)</li>
            <li>Eugene Yee (19)</li>
            <li>Rodney Bacigalupo (18)</li>
            <li>Antony Saccenti (17)</li>
            <li>Chris Wildes (13)</li>
            <li>Rob Murray (12)</li>
            <li>Dalton Versak (10)</li>
            <li>Dave Rohde (10)</li>
            <li>Andy Latto (8)</li>
            <li>Marcy Morelli (7)</li>
          </ul>
        </div>
        <br />
      </div>
      <div className='Stats_2020'>
        <h1 className='Stats_header'>2020 Totals</h1>
        <div className='centerText Stats_nameList'>
          <ul>
            <li>
              <strong>Rodney Bacigalupo (34)</strong>
            </li>
            <li>Kyle Smith (36)</li>
            <li>Joe Yaure (25)</li>
            <li>Donte Saccenti (24)</li>
            <li>Aaron Blair (22)</li>
            <li>Antony Saccenti (20)</li>
            <li>Scott Saccenti (20)</li>
            <li>Eugene Yee (19)</li>
            <li>Chad Weaver (19)</li>
            <li>Dalton Versak (18)</li>
            <li>Rob Murray (17)</li>
            <li>Preston Saccenti (13)</li>
          </ul>
        </div>
        <br />
      </div>
      <div className='Stats_2021'>
        <h1 className='Stats_header'>2021 Totals</h1>
        <div className='centerText Stats_nameList'>
          <ul>
            <li>
              <strong>Andrew Emerick (44)</strong>
            </li>
            <li>Jay Fox (34)</li>
            <li>Antony Saccenti (33)</li>
            <li>Chad Weaver (27)</li>
            <li>Dalton Versak (26)</li>
            <li>Donte Saccenti (24)</li>
            <li>Aaron Blair (23)</li>
            <li>Chris Wildes (19)</li>
            <li>Kyle Smith (17)</li>
            <li>Rob Murray (16)</li>
            <li>Rodney Bacigalupo (16)</li>
            <li>Eugene Yee (15)</li>
            <li>Joe Yaure (13)</li>
            <li>Chris Yaure (11)</li>
            <li>Scott Saccenti (11)</li>
            <li>Preston Saccenti (7)</li>
          </ul>
        </div>
        <br />
      </div>
      <div className='Stats_2022'>
        <h1 className='Stats_header'>2022 Totals</h1>
        <div className='centerText Stats_nameList'>
          <ul>
            <li>
              <strong>Kyle Smith (38)</strong>
            </li>
            <li>Antony Saccenti (38)</li>
            <li>Marcy Morelli (36)</li>
            <li>Andrew Emerick (34)</li>
            <li>Scott Saccenti (30)</li>
            <li>Chris Wildes (27)</li>
            <li>Dalton Versak (26)</li>
            <li>Rob Murray (23)</li>
            <li>Eugene Yee (21)</li>
            <li>Chris Yaure (20)</li>
            <li>Joe Yaure (20)</li>
            <li>Donte Saccenti (20)</li>
            <li>Preston Saccenti (19)</li>
            <li>Aaron Blair (16)</li>
            <li>Chad Weaver (11)</li>
            <li>Rodney Bacigalupo (9)</li>
          </ul>
        </div>
        <br />
      </div>
      <div className='Stats_2023'>
        <h1 className='Stats_header'>2023 Totals</h1>
        <div className='centerText Stats_nameList'>
          <ul>
            <li>
              <strong>Andrew Emerick (40)</strong>
            </li>
            <li>Rob Murray (34)</li>
            <li>Randy Buehler (34)</li>
            <li>Chris Wildes (31)</li>
            <li>Antony Saccenti (30)</li>
            <li>Donte Saccenti (29)</li>
            <li>Joe Yaure (27)</li>
            <li>Scott Saccenti (25)</li>
            <li>Dalton Versak (22)</li>
            <li>Chad Weaver (22)</li>
            <li>Eugene Yee (19)</li>
            <li>Marcy Morelli (19)</li>
            <li>Chris Yaure (18)</li>
            <li>Kyle Smith (16)</li>
            <li>Preston Saccenti (16)</li>
            <li>Aaron Blair (8)</li>
          </ul>
        </div>
        <br />
      </div>
      <div className='Stats_2024'>
        <h1 className='Stats_header'>2024 Totals</h1>
        <div className='centerText Stats_nameList'>
          <ul>
            <li>
              <strong>Antony Saccenti (37)</strong>
            </li>
            <li>Andrew Emerick (40)</li>
            <li>Preston Saccenti (34)</li>
            <li>Scott Saccenti (33)</li>
            <li>Chris Wildes (29)</li>
            <li>Chad Weaver (29)</li>
            <li>Kyle Smith (23)</li>
            <li>Rob Murray (20)</li>
            <li>Hilary Smith (18)</li>
            <li>Andy Latto (15)</li>
            <li>Donte Saccenti (15)</li>
            <li>Eugene Yee (14)</li>
            <li>Rodney Bacigalupo (12)</li>
            <li>Christy Applegate (12)</li>
            <li>Joe Yaure (12)</li>
            <li>Dalton Versak (12)</li>
            <li>Henry Dove (11)</li>
            <li>Randy Buehler (10)</li>
            <li>Marcy Morelli (9)</li>
            <li>Aaron Blair (9)</li>
          </ul>
        </div>
        <br />
      </div>
      <div className='Stats_2025'>
        <h1 className='Stats_header'>2025 Totals</h1>
        <div className='centerText Stats_nameList'>
          <ul>
            <li>
              <strong>Chris Wildes (33)</strong>
            </li>
            <li>Scott Saccenti (36)</li>
            <li>Rodney Bacigalupo (33)</li>
            <li>Dalton Versak (29)</li>
            <li>Antony Saccenti (25)</li>
            <li>Donte Saccenti (23)</li>
            <li>Eugene Yee (22)</li>
            <li>Marcy Morelli (22)</li>
            <li>Andrew Emerick (20)</li>
            <li>Andy Latto (20)</li>
            <li>Rob Murray (19)</li>
            <li>Joe Yaure (19)</li>
            <li>Chad Weaver (19)</li>
            <li>Preston Saccenti (17)</li>
            <li>Aaron Blair (16)</li>
            <li>Christy Applegate (8)</li>
          </ul>
        </div>
        <br />
      </div>
      <br />
      <div className='Stats_2026'>
        <h1 className='Stats_header'>2026 Totals</h1>
        <div className='centerText Stats_nameList'>
          <ul>
            <li>
              <strong>Joe Yaure (38)</strong>
            </li>
            <li>Andrew Emerick (37)</li>
            <li>Dalton Versak (32)</li>
            <li>Chris Wildes (31)</li>
            <li>Antony Saccenti (29)</li>
            <li>Andy Latto (29)</li>
            <li>Donte Saccenti (28)</li>
            <li>Scott Saccenti (27)</li>
            <li>Rob Murray (21)</li>
            <li>Aaron Blair (21)</li>
            <li>Preston Saccenti (20)</li>
            <li>Chad Weaver (20)</li>
            <li>Randy Buehler (18)</li>
            <li>Tessa Lytle (17)</li>
            <li>Christy Applegate (16)</li>
            <li>Eugene Yee (16)</li>
            <li>Henry Dove (16)</li>
            <li>Marcy Morelli (15)</li>
            <li>Kyle Smith (14)</li>
            <li>Rodney Bacigalupo (4)</li>
          </ul>
        </div>
        <br />
      </div>
      <br />
      <br />
      <br />
    </div>
  );
};

export default stats;
